
































































import {Component, PropSync} from 'vue-property-decorator'
import BaseFilter from "@/components/Filter/BaseFilter";
import {ModerationTemplateFilter} from "@/store/user_management/template_moderation/types";
import {SelectWings} from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings}})
export default class ModerationTemplatesFilter extends BaseFilter<ModerationTemplateFilter>{
  @PropSync('show') is_show!: boolean;
  @Getter("transports") transportsList: any;
  @Getter("templatesStatusList") statusList: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getModerationTemplates") actionGetModerationTemplates: any;

  defaultFilter(): ModerationTemplateFilter {
    return {
      partner: undefined,
      channel: undefined,
      status: undefined
    };
  }

  partnersList: any = [];
  filterKeys: object = {
    "transport" : "channel"
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  get transportsForOriginatorsList() {
    return this.transportsList.filter((value:any) => value.name.toLowerCase() !== 'ussd')
  }

  async created() {
    this.actionGetTransports();
    this.actionGetModerationTemplates(this.filter);
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Template",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      await this.actionGetModerationTemplates(this.filter);
      await this.actionLog(this.logObject);
    } catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }
}
